import axios from 'axios';


// Configuração do axios para comunicação com o backend
const apiClient = axios.create({
  baseURL: 'https://api.plannedbr.com.br/',
  // baseURL: 'https://apiwebponto.onlogic.com.br/',
  // baseURL: 'http://localhost:8000',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000
});

// Interceptor para adicionar token JWT em todas as requisições
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Interceptor para tratamento de erros de resposta
apiClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Tratamento de erro de autenticação (401)
    if (error.response && error.response.status === 401) {
      // Limpar token e redirecionar para login
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
